import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;
export const ContentContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;
export const HeaderConfiguration = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 3px;
    margin-top: -10px;

    span {
        margin-left: 10px;

        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 36px;
        display: flex;
        align-items: center;
        color: #FFFFFF;
    }
`
export const TitleContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;

    span {
        font-size: 18px;
        font-family: 'Roboto', sans-serif;
        color: ${props => props.theme.primaryColor};
    }
`
export const Separator = styled.div`
    display: flex;
    width: 100%;
    border: 1px solid ${props => props.theme.primaryColor};
    margin-top: 10px;
    margin-bottom: 10px;
`
export const AudioFormContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
`
export const LabelContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    label {
        font-size: 14px;
        font-family: 'Roboto', sans-serif;
        color: ${props => props.theme.primaryColor};
    }

    select {
        display: inline-block;
        vertical-align: top;
        overflow-x: auto;

        font-size: 14px;
        font-family: 'Roboto', sans-serif;
        width: 100%;
        height: 40px;
        border: none;
        border-radius: 5px;
      
        option {
            font-size: 11px;
        }
    }
`
export const Audio = styled.audio`
  width: 100%;
  height: 28px;
  margin-top: 10px;
`
export const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 5px;
    background-color: ${props => props.theme.buttonBackColor};
    margin-top: 10px;
    font-size: 22px;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: ${props => props.theme.primaryColor};
    cursor: pointer;
`
export const AlertContainer = styled.div`
    display: flex;
    width: 250px;
    height: 200px;
    position: absolute;
    flex-direction: column;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    border-radius: 5px;
    justify-content: center !important;
    align-items: center !important;

    background: ${props => props.theme.asideColor};

    h1 {
        font-size: 22px;
        color: ${props => props.theme.secondaryColor};
    }

    div {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
    }

`